import React, { Fragment } from 'react'
import { FormGroup, ControlLabel, FormControl, Button, Row, Col } from 'react-bootstrap'
import { getParams, end_point } from './helper'
import DatePicker from 'react-datepicker'
import { makeUniqueKey, makeOptions } from './helper'
import Moment from 'moment'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/free-solid-svg-icons'
var $ = require('jquery')

class UserForm extends React.Component {
  constructor(props) {
    super(props);
    var type = props.selectedItem ? props.selectedItem.type : "user";

    if (props.mode === "edit") {
      if (type === "parent") {
        const extras = props.selectedItem.extras || {}
        const secondaryParent = extras.secondary_parent || {}
        var defaultPlaceholders = {
          _id: props.selectedItem._id,
          first_name: props.selectedItem.first_name,
          last_name: props.selectedItem.last_name,
          email: props.selectedItem.email,
          phone: extras.phone,
          secondary_parent_first_name: secondaryParent.first_name,
          secondary_parent_last_name: secondaryParent.last_name,
          secondary_parent_email: secondaryParent.email,
          secondary_parent_phone: secondaryParent.phone,
        }
      } else if (type === "athlete"){
        const extras = props.selectedItem.extras || {}
        defaultPlaceholders = {
          first_name: props.selectedItem.first_name,
          last_name: props.selectedItem.last_name,
          email: props.selectedItem.email,
          phone: extras.phone,
          date_of_birth: extras.date_of_birth,
          gender: extras.gender,
          address: extras.address,
          postal_code: extras.postal_code,
          city: extras.city,
          province: extras.province,
          current_school: extras.current_school,
          parent_notes: extras.parent_notes,
          parent_id: props.selectedItem.parent_id,
          udfs: props.selectedItem.udfs ? props.selectedItem.udfs: null
        }
      } else {
        const extras = props.selectedItem.extras || {}
        defaultPlaceholders = {
          first_name: props.selectedItem.first_name,
          last_name: props.selectedItem.last_name,
          email: props.selectedItem.email,
          phone: extras.phone,
          date_of_birth: extras.date_of_birth,
        }
      }
    } else {
      defaultPlaceholders = {
        first_name: "",
        last_name: "",
        email: "",
        type: "",
        phone: "",
        date_of_birth: null,
        orgUDFs: null
      }
    }
    var date_of_birth = type !== "parent" ? (Moment.utc(defaultPlaceholders.date_of_birth).isValid() ? Moment.utc(defaultPlaceholders.date_of_birth): null): null;
    var parent_id = type === "athlete" ? defaultPlaceholders.parent_id : null;

    this.state = {
      token: getParams().jwt,
      organization_id: localStorage.getItem("organization_id"),
      mode: props.mode,
      user_mode: type,
      defaultPlaceholders: defaultPlaceholders,
      parents: [],//should be narrowed down through query,
      date_of_birth: date_of_birth,
      parent_id: parent_id,
      spinner: false,
      athletes: [],
      editableCards: {},
      familyCardDates: {},
      familyDirty: false,
      familyDraft: this.buildFamilyDraft(defaultPlaceholders, [])
    }
    this.familyInitialSnapshot = null
  }

  buildFamilyDraft = (defaultPlaceholders, parents = []) => {
    const familyMembers = parents.filter((athlete) => {
      return athlete.type === "athlete" && athlete.parent_id === defaultPlaceholders._id
    })

    return {
      accountHolder: {
        first_name: defaultPlaceholders.first_name || '',
        last_name: defaultPlaceholders.last_name || '',
        email: defaultPlaceholders.email || '',
        phone: defaultPlaceholders.phone || ''
      },
      secondaryContact: {
        first_name: defaultPlaceholders.secondary_parent_first_name || '',
        last_name: defaultPlaceholders.secondary_parent_last_name || '',
        email: defaultPlaceholders.secondary_parent_email || '',
        phone: defaultPlaceholders.secondary_parent_phone || ''
      },
      participants: familyMembers.map((athlete) => {
        const extras = athlete.extras || {}
        return {
          _id: athlete._id,
          first_name: athlete.first_name || '',
          last_name: athlete.last_name || '',
          email: athlete.email || '',
          phone: extras.phone || '',
          date_of_birth: extras.date_of_birth ? Moment.utc(extras.date_of_birth).toDate() : null,
          gender: extras.gender || '',
          current_school: extras.current_school || '',
          city: extras.city || '',
          address: extras.address || '',
          province: extras.province || '',
          postal_code: extras.postal_code || '',
          parent_notes: extras.parent_notes || '',
          parent_id: athlete.parent_id || defaultPlaceholders._id,
          udfs: athlete.udfs ? athlete.udfs : null
        }
      })
    }
  }

  handleChangeType = (e) => {
    this.setState({ user_mode: e });
  }

  handleCloseModal = () => {
    this.setState({
      familyDirty: false,
      editableCards: {},
      familyCardDates: {},
      familyDraft: this.buildFamilyDraft(this.state.defaultPlaceholders, this.state.parents)
    }, () => {
      if (this.props.setWhenDirty) {
        this.props.setWhenDirty(false)
      }
    })
    this.state.mode === "edit" ? this.props.handleCloseModalEdit() : this.props.handleCloseModalNew()
  }

  handleParentChange = (e) => {
    this.setState({ parent_id: e.target.value })
  }
  handleDateOfBirthChange = (date_of_birth) => {
    this.setState({ date_of_birth })
  }

  toggleCardEditing = (cardKey) => {
    this.setState((prevState) => ({
      editableCards: {
        ...prevState.editableCards,
        [cardKey]: !prevState.editableCards[cardKey]
      }
    }), this.updateFamilyDirtyState)
  }

  isCardEditing = (cardKey) => {
    return !!this.state.editableCards[cardKey]
  }

  getInputValue = (id, fallback = '') => {
    const input = document.getElementById(id)
    return input ? input.value : fallback
  }

  getFamilyDraft = () => {
    return this.state.familyDraft || this.buildFamilyDraft(this.state.defaultPlaceholders, this.state.parents)
  }

  getFamilySnapshotFromDraft = (familyDraft) => {
    const normalizeText = (value) => {
      if (value === null || value === undefined) {
        return ''
      }
      return `${value}`.trim()
    }

    const normalizeDate = (value) => {
      if (!value) {
        return ''
      }
      const normalizedDate = Moment.utc(value)
      return normalizedDate.isValid() ? normalizedDate.format('YYYY-MM-DD') : ''
    }

    return {
      accountHolder: {
        first_name: normalizeText(familyDraft.accountHolder.first_name),
        last_name: normalizeText(familyDraft.accountHolder.last_name),
        email: normalizeText(familyDraft.accountHolder.email),
        phone: normalizeText(familyDraft.accountHolder.phone)
      },
      secondaryContact: {
        first_name: normalizeText(familyDraft.secondaryContact.first_name),
        last_name: normalizeText(familyDraft.secondaryContact.last_name),
        email: normalizeText(familyDraft.secondaryContact.email),
        phone: normalizeText(familyDraft.secondaryContact.phone)
      },
      participants: familyDraft.participants.map((participant) => ({
        _id: participant._id,
        first_name: normalizeText(participant.first_name),
        last_name: normalizeText(participant.last_name),
        email: normalizeText(participant.email),
        phone: normalizeText(participant.phone),
        date_of_birth: normalizeDate(participant.date_of_birth),
        gender: normalizeText(participant.gender),
        current_school: normalizeText(participant.current_school),
        city: normalizeText(participant.city),
        address: normalizeText(participant.address),
        province: normalizeText(participant.province),
        postal_code: normalizeText(participant.postal_code)
      }))
    }
  }

  setFamilyDraftField = (section, field, value, participantId = null) => {
    this.setState((prevState) => {
      const familyDraft = {
        ...prevState.familyDraft,
        accountHolder: {
          ...prevState.familyDraft.accountHolder
        },
        secondaryContact: {
          ...prevState.familyDraft.secondaryContact
        },
        participants: prevState.familyDraft.participants.map((participant) => ({ ...participant }))
      }

      if (section === 'accountHolder') {
        familyDraft.accountHolder[field] = value
      } else if (section === 'secondaryContact') {
        familyDraft.secondaryContact[field] = value
      } else if (section === 'participant' && participantId) {
        familyDraft.participants = familyDraft.participants.map((participant) => {
          if (participant._id !== participantId) {
            return participant
          }
          return {
            ...participant,
            [field]: value
          }
        })
      }

      return { familyDraft }
    }, this.updateFamilyDirtyState)
  }

  getFamilyDraftValue = (section, field, fallback = '', participantId = null) => {
    const familyDraft = this.getFamilyDraft()
    if (section === 'accountHolder') {
      return familyDraft.accountHolder[field] !== undefined ? familyDraft.accountHolder[field] : fallback
    }
    if (section === 'secondaryContact') {
      return familyDraft.secondaryContact[field] !== undefined ? familyDraft.secondaryContact[field] : fallback
    }
    if (section === 'participant' && participantId) {
      const participant = familyDraft.participants.find((item) => item._id === participantId)
      return participant && participant[field] !== undefined ? participant[field] : fallback
    }
    return fallback
  }

  normalizeSnapshotValue = (value, type = 'text') => {
    if (value === null || value === undefined) {
      return ''
    }

    if (type === 'date') {
      const normalizedDate = Moment.utc(value)
      return normalizedDate.isValid() ? normalizedDate.format('YYYY-MM-DD') : ''
    }

    return `${value}`.trim()
  }

  getFamilySnapshot = () => {
    return this.getFamilySnapshotFromDraft(this.getFamilyDraft())
  }

  updateFamilyDirtyState = () => {
    if (this.state.user_mode !== "parent" || !this.familyInitialSnapshot) {
      return
    }

    const currentSnapshot = this.getFamilySnapshot()
    const isDirty = JSON.stringify(currentSnapshot) !== JSON.stringify(this.familyInitialSnapshot)
    if (isDirty !== this.state.familyDirty) {
      this.setState({ familyDirty: isDirty }, () => {
        if (this.props.setWhenDirty) {
          this.props.setWhenDirty(isDirty)
        }
      })
    }
  }

  getFamilyMembers = () => {
    const { parents, defaultPlaceholders } = this.state
    return parents.filter((athlete) => {
      return athlete.type === "athlete" && athlete.parent_id === defaultPlaceholders._id
    })
  }

  getParentFormFields = () => {
    return {
      "first_name": this.getInputValue("first_name", this.state.defaultPlaceholders.first_name || ''),
      "last_name": this.getInputValue("last_name", this.state.defaultPlaceholders.last_name || ''),
      "email": this.getInputValue("email", this.state.defaultPlaceholders.email || ''),
      "extras": {
        "phone": this.getInputValue("phone", this.state.defaultPlaceholders.phone || ''),
        "secondary_parent": {
          "first_name": this.getInputValue("secondary_parent_first_name", this.state.defaultPlaceholders.secondary_parent_first_name || ''),
          "last_name": this.getInputValue("secondary_parent_last_name", this.state.defaultPlaceholders.secondary_parent_last_name || ''),
          "email": this.getInputValue("secondary_parent_email", this.state.defaultPlaceholders.secondary_parent_email || ''),
          "phone": this.getInputValue("secondary_parent_phone", this.state.defaultPlaceholders.secondary_parent_phone || '')
        }
      },
      "type": "parent"
    }
  }

  getParticipantFormFields = (athlete) => {
    const extras = athlete.extras || {}
    const cardKey = `participant-${athlete._id}`
    return {
      "first_name": this.getInputValue(`${cardKey}-first_name`, athlete.first_name || ''),
      "last_name": this.getInputValue(`${cardKey}-last_name`, athlete.last_name || ''),
      "email": this.getInputValue(`${cardKey}-email`, athlete.email || ''),
      "extras": {
        "phone": this.getInputValue(`${cardKey}-phone`, extras.phone || ''),
        "date_of_birth": this.getInputValue(`${cardKey}-date_of_birth`, extras.date_of_birth || ''),
        "gender": this.getInputValue(`${cardKey}-gender`, extras.gender || ''),
        "address": this.getInputValue(`${cardKey}-address`, extras.address || ''),
        "postal_code": this.getInputValue(`${cardKey}-postal_code`, extras.postal_code || ''),
        "city": this.getInputValue(`${cardKey}-city`, extras.city || ''),
        "province": this.getInputValue(`${cardKey}-province`, extras.province || ''),
        "current_school": this.getInputValue(`${cardKey}-current_school`, extras.current_school || ''),
        "parent_notes": this.getInputValue(`${cardKey}-parent_notes`, extras.parent_notes || ''),
      },
      "type": "athlete",
      "parent_id": this.getInputValue(`${cardKey}-parent_id`, athlete.parent_id || this.state.defaultPlaceholders._id),
      "udfs": athlete.udfs ? athlete.udfs : null
    }
  }

  getCardFieldDisplayValue = (field) => {
    if (field.type === 'date') {
      const value = this.state.familyCardDates[field.id] || field.selectedValue || field.defaultValue
      return value ? Moment.utc(value).format('MMM DD, YYYY') : '-'
    }

    if (field.type === 'select') {
      const raw = field.defaultValue || ''
      if (typeof raw === 'string' && raw.length > 0) {
        return raw.charAt(0).toUpperCase() + raw.slice(1)
      }
      return raw || '-'
    }

    return field.defaultValue || '-'
  }

  handleFamilyCardDateChange = (fieldId, date) => {
    this.setState((prevState) => ({
      familyCardDates: {
        ...prevState.familyCardDates,
        [fieldId]: date
      }
    }))

    const participantMatch = fieldId.match(/^participant-(.*)-date_of_birth$/)
    if (participantMatch) {
      this.setFamilyDraftField('participant', 'date_of_birth', date, participantMatch[1])
    }
  }

  patchUserRecord = (change, id) => {
    return $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id
      },
      method: "PATCH",
      contentType: "application/json",
      data: JSON.stringify({
        "id": id,
        "change": change
      }),
      url: `${end_point('users')}/users`,
    })
  }

  handleParentUpdateSubmit = () => {
    this.setState({ spinner: true })
    if (!this.checkFields("update")) {
      this.setState({ spinner: false })
      return
    }

    const familyMembers = this.getFamilyMembers()
    const familyDraft = this.getFamilyDraft()
    const familySnapshot = this.getFamilySnapshotFromDraft(familyDraft)
    const initialSnapshot = this.familyInitialSnapshot || familySnapshot
    const updateRequests = []

    const parentPayload = {
      first_name: familyDraft.accountHolder.first_name,
      last_name: familyDraft.accountHolder.last_name,
      email: familyDraft.accountHolder.email,
      extras: {
        phone: familyDraft.accountHolder.phone,
        secondary_parent: {
          first_name: familyDraft.secondaryContact.first_name,
          last_name: familyDraft.secondaryContact.last_name,
          email: familyDraft.secondaryContact.email,
          phone: familyDraft.secondaryContact.phone
        }
      },
      type: "parent"
    }

    if (JSON.stringify(familySnapshot.accountHolder) !== JSON.stringify(initialSnapshot.accountHolder) ||
      JSON.stringify(familySnapshot.secondaryContact) !== JSON.stringify(initialSnapshot.secondaryContact)) {
      updateRequests.push(this.patchUserRecord(parentPayload, this.props.selectedItem._id))
    }

    familyMembers.forEach((athlete) => {
      const participantDraft = familySnapshot.participants.find((participant) => participant._id === athlete._id)
      const initialParticipant = initialSnapshot.participants.find((participant) => participant._id === athlete._id)
      if (participantDraft && initialParticipant && JSON.stringify(participantDraft) !== JSON.stringify(initialParticipant)) {
        updateRequests.push(this.patchUserRecord(this.getParticipantFormFieldsFromDraft(athlete, participantDraft), athlete._id))
      }
    })

    if (updateRequests.length === 0) {
      this.setState({ spinner: false, familyDirty: false }, () => {
        if (this.props.setWhenDirty) {
          this.props.setWhenDirty(false)
        }
      })
      return
    }

    Promise.all(updateRequests)
      .then((results) => {
        const failedResult = results.find(result => result && result.errorMessage)
        if (failedResult) {
          alert(failedResult.errorMessage)
          this.setState({ spinner: false })
          return
        }
        this.familyInitialSnapshot = familySnapshot
        this.setState({ spinner: false, familyDirty: false, editableCards: {} }, () => {
          if (this.props.setWhenDirty) {
            this.props.setWhenDirty(false)
          }
        })
        this.props.handleCloseModalEdit()
        window.location.reload()
      })
      .catch(() => {
        alert("Unable to update the family details at the moment, please contact support")
        this.setState({ spinner: false })
      })
  }
  componentDidMount() {
    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id
      },
      method: "GET",
      dataType: "json",
      url: `${end_point('users')}/users`,
    }).then(this.usersGetHandler.bind(this))

    $.ajax({
      headers: {
        "token": this.state.token,
        "organization_id": this.state.organization_id,
        "league": false
      },
      method: "GET",
      dataType: "json",
      url: `${end_point('organizations')}/organizations`,
    }).then(org => {
      this.setState({ orgUDFs: org.udfs ? org.udfs : null })
    });

  }

  usersGetHandler(data) {
    const parents = data.message || []
    this.familyInitialSnapshot = null
    this.setState({ parents }, () => {
      if (this.state.user_mode === "parent") {
        const familyDraft = this.buildFamilyDraft(this.state.defaultPlaceholders, parents)
        this.familyInitialSnapshot = this.getFamilySnapshotFromDraft(familyDraft)
        this.setState({ familyDirty: false, familyDraft }, () => {
          if (this.props.setWhenDirty) {
            this.props.setWhenDirty(false)
          }
        })
      }
    })
  }

  handleUpdateSubmit = () => {
    if (this.state.user_mode === "parent") {
      this.handleParentUpdateSubmit()
      return
    }

    this.setState({spinner: true})
    var check = this.checkFields("update")
    var formFields = this.getFormFields()
    console.log("update user - formFields", formFields)
    if(check){
      this.props.patchUpdateMethod(formFields, this.props.selectedItem._id);
    } else {
      this.setState({spinner: false})
    }
  }

  handleArchiveSubmit = () => {
    if (window.confirm(`Are you sure to archive ${document.getElementById("first_name").value} ${document.getElementById("last_name").value}?`)) {
      this.setState({spinner: true})
      var formFields = { archived: true, email: document.getElementById("email").value };
      this.props.patchUpdateMethod(formFields, this.props.selectedItem._id);
    }
  }

  getFormFields() {
    if (this.state.user_mode === "athlete") {
      return {
        "first_name": document.getElementById("first_name").value,
        "last_name": document.getElementById("last_name").value,
        "email": document.getElementById("email").value,
        "extras": {
          "phone": document.getElementById("phone").value,
          "date_of_birth": document.getElementById("date_of_birth").value,
          "gender": document.getElementById("gender").value,
          "address": document.getElementById("address").value,
          "postal_code": document.getElementById("postal_code").value,
          "city": document.getElementById("city").value,
          "province": document.getElementById("province").value,
          "current_school": document.getElementById("current_school").value,
          "parent_notes": document.getElementById("parent_notes").value,
        },
        "type": "athlete",
        "parent_id": document.getElementById("parent_id").value,
        "udfs": this.state.defaultPlaceholders.udfs
      }
    } else if (this.state.user_mode === "parent") {
      const familyDraft = this.getFamilyDraft()
      return {
        "first_name": familyDraft.accountHolder.first_name,
        "last_name": familyDraft.accountHolder.last_name,
        "email": familyDraft.accountHolder.email,
        "extras": {
          "phone": familyDraft.accountHolder.phone,
          "secondary_parent": {
            "first_name": familyDraft.secondaryContact.first_name,
            "last_name": familyDraft.secondaryContact.last_name,
            "email": familyDraft.secondaryContact.email,
            "phone": familyDraft.secondaryContact.phone
          }
        },
        "type": "parent"
      }
    } else {
      return {
        "first_name": document.getElementById("first_name").value,
        "last_name": document.getElementById("last_name").value,
        "email": document.getElementById("email").value,
        "extras": {
          "phone": document.getElementById("phone").value,
          "date_of_birth": document.getElementById("date_of_birth").value
          },
        "type": document.getElementById("type").value
      }
    }
  }

  getParticipantFormFieldsFromDraft = (athlete, participantDraft) => {
    return {
      "first_name": participantDraft.first_name,
      "last_name": participantDraft.last_name,
      "email": participantDraft.email,
      "extras": {
        "phone": participantDraft.phone,
        "date_of_birth": participantDraft.date_of_birth ? Moment.utc(participantDraft.date_of_birth).format('YYYY-MM-DD') : '',
        "gender": participantDraft.gender,
        "address": participantDraft.address,
        "postal_code": participantDraft.postal_code,
        "city": participantDraft.city,
        "province": participantDraft.province,
        "current_school": participantDraft.current_school,
        "parent_notes": participantDraft.parent_notes,
      },
      "type": "athlete",
      "parent_id": participantDraft.parent_id || athlete.parent_id || this.state.defaultPlaceholders._id,
      "udfs": participantDraft.udfs ? participantDraft.udfs : athlete.udfs ? athlete.udfs : null
    }
  }

  renderFamilyCardField = (cardKey, field) => {
    const editable = this.isCardEditing(cardKey)
    const inputProps = {
      className: "opaque-grey family-card-input",
      name: field.id,
      id: field.id,
      value: field.value || '',
      onChange: field.onChange
    }

    if (field.type === 'select') {
      return (
        <Col lg={field.col.lg} sm={field.col.sm} key={field.id}>
          <FormGroup>
            <ControlLabel>{field.label}</ControlLabel>
            <FormControl
              {...inputProps}
              componentClass="select"
              disabled={!editable}
            >
              {field.options}
            </FormControl>
          </FormGroup>
        </Col>
      )
    }

    if (field.type === 'date') {
      const selectedValue = this.state.familyCardDates[field.id] || field.selectedValue || null
      return (
        <Col lg={field.col.lg} sm={field.col.sm} key={field.id}>
          <FormGroup>
            <ControlLabel>{field.label}</ControlLabel>
              <DatePicker
                className="opaque-grey form-control family-card-input"
                name={field.id}
                id={field.id}
                utcOffset={0}
                selected={selectedValue}
                placeholderText={field.placeholder || "MM/DD/YYYY"}
                showYearDropdown
              onChange={field.onChange}
                disabled={!editable}
              />
          </FormGroup>
        </Col>
      )
    }

    return (
      <Col lg={field.col.lg} sm={field.col.sm} key={field.id}>
        <FormGroup>
          <ControlLabel>{field.label}</ControlLabel>
          <FormControl
            {...inputProps}
            type={field.type || 'text'}
            readOnly={!editable}
          />
        </FormGroup>
      </Col>
    )
  }

  renderFamilyCard = (cardKey, title, subtitle, fields, summaryFields = []) => {
    const editable = this.isCardEditing(cardKey)
    const visibleSummaryFields = summaryFields.length ? summaryFields : fields.slice(0, 4)
    return (
      <div className={`family-edit-card ${editable ? 'is-editing' : ''}`}>
        <div className="family-edit-card-header">
          <div>
            <div className="family-edit-card-title">{title}</div>
            {subtitle ? <div className="family-edit-card-subtitle">{subtitle}</div> : null}
          </div>
          <button
            type="button"
            className={`family-edit-card-toggle ${editable ? 'is-active' : ''}`}
            onClick={() => this.toggleCardEditing(cardKey)}
            aria-label={`Edit ${title}`}
          >
            <FontAwesomeIcon icon={faPen} />
          </button>
        </div>
        {editable ? (
          <div className="family-edit-card-body">
            <Row>
              {fields.map((field) => this.renderFamilyCardField(cardKey, field))}
            </Row>
          </div>
        ) : (
          <div className="family-summary-grid family-summary-grid-compact">
            {visibleSummaryFields.map((field) => (
              <div key={field.id}>
                <span>{field.label}</span>
                <div>{this.getCardFieldDisplayValue(field)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
    )
  }

  handleNewSubmit = () => {
    this.setState({spinner: true})
    var check = this.checkFields("new")
    var formFields = this.getFormFields();
    if (check && window.confirm(`You are about to make ${formFields.first_name} an ${formFields.type}.  Would you like to proceed?`)) {
      this.props.postMethod(formFields);
    } else if (!check) {
      this.setState({spinner: false})
    }
  }

  checkUDFFields = () => {
    const { orgUDFs, defaultPlaceholders } = this.state
    var found = defaultPlaceholders.udfs.find(udf => {
      return udf.value === "" || udf.value === 0
    })

    if (found) {
      var required = orgUDFs.find(udf => {
        console.log("udf", udf)
        return udf.required === true && udf.key === found.key
      })
    }
    if (found && required) {
      alert(`Please enter ${required.label}`)
      return false
    } else {
      return true
    }
  }

  checkFields(type){
    if(type === "new" || type === "update"){
      if (this.state.user_mode === "parent") {
        const familyDraft = this.getFamilyDraft()
        const accountHolder = familyDraft.accountHolder || {}

        if (!`${accountHolder.first_name || ''}`.trim()){
          alert("First name is empty");
          return false;
        } else if (!`${accountHolder.last_name || ''}`.trim()){
          alert("Last name is empty");
          return false;
        } else if (!`${accountHolder.email || ''}`.trim()){
          alert("Email is empty");
          return false;
        } else if (!`${accountHolder.phone || ''}`.trim()){
          alert("Phone is empty");
          return false;
        } else if (this.state.orgUDFs && this.state.defaultPlaceholders.udfs) {
          var udfCheck = this.checkUDFFields()
          return udfCheck
        } else {
          return true
        }
      }

      if (document.getElementById("first_name").value === ""){
        alert("First name is empty");
        return false;
      } else if (document.getElementById("last_name").value === ""){
        alert("Last nameis empty");
        return false;
      } else if (document.getElementById("email").value === ""){
        alert("Email is empty");
        return false;
      } else if (document.getElementById("phone").value === ""){
        alert("Phone is empty");
        return false;
      } else if (document.getElementById("type") && document.getElementById("type").value === ""){
        alert("Please choose a type");
        return false;
      } else if (this.state.orgUDFs && this.state.defaultPlaceholders.udfs) {
        var udfCheck = this.checkUDFFields()
        return udfCheck
      } else {
        return true
      }
    }
  }

  handleUDFChanges = (udf, e, number) => {
    var athleteInfo = this.state.defaultPlaceholders
    var changeUDFs = athleteInfo.udfs.slice()
    var val = e.target ? e.target.value : e
    var udfChange = changeUDFs.find(prevUDF => {return prevUDF.key === udf && JSON.stringify(this.state.organization_id) === JSON.stringify(prevUDF.organization_id)})
    var index = changeUDFs.indexOf(udfChange)
    if (udfChange) {
      udfChange.value = number ? +val : val
      changeUDFs[index] = udfChange
      athleteInfo.udfs = changeUDFs
      this.setState({ defaultPlaceholders: athleteInfo })
    }
  }

  UDFinfo = (udfs) => {
    const { orgUDFs, organization_id } = this.state
    return (
      udfs.map((udf, index) => {
        var orgUDF = orgUDFs.find(orgudf => { return orgudf.key === udf.key && JSON.stringify(organization_id) === JSON.stringify(udf.organization_id)})
        if (orgUDF) {
          return (
            <Col key={index} sm={4}>
              <FormGroup>
                  <ControlLabel>{orgUDF.label}</ControlLabel>
                  {
                    orgUDF.type.format === 'list' ?

                      <FormControl  className="opaque-grey" name={orgUDF.label} componentClass="select" id={orgUDF.label} defaultValue={udf.value} 
                      onChange={(e) => this.handleUDFChanges(udf.key, e)}
                      >
                      {makeOptions(orgUDF)}
                    </FormControl>

                    :
                    orgUDF.type.format === 'number' ?
                  
                    <FormControl className="opaque-grey" name={orgUDF.label} id={orgUDF.label} placeholder="" type="number" min="0" defaultValue={udf.value} 
                    onChange={(e) => this.handleUDFChanges(udf.key, e, 'number')}
                    />

                    :
                   
                    <FormControl className="opaque-grey" name={orgUDF.label} type="text" id={orgUDF.label} placeholder="" defaultValue={udf.value} 
                    onChange={(e) => this.handleUDFChanges(udf.key, e)}
                    />

                  }  
              </FormGroup>
            </Col>
          )
        }
      })
    )
  }

  render() {
    const { defaultPlaceholders, date_of_birth, orgUDFs, user_mode, parents } = this.state
    const familyDraft = this.getFamilyDraft()
    const displayName = `${defaultPlaceholders.first_name || ''} ${defaultPlaceholders.last_name || ''}`.trim()
    const modalTitle = this.state.mode === 'new' ? 'Create New User' : 'Edit User'
    const modalSubtitle = displayName || `${user_mode ? user_mode.charAt(0).toUpperCase() + user_mode.slice(1) : 'User'} details`
    const modalSummaryValue = user_mode ? user_mode.charAt(0).toUpperCase() + user_mode.slice(1) : '-'
    var submitButtons = [];

    submitButtons.push(


 

      );
      submitButtons.push(" ")
    if (this.state.mode === "edit") {
      submitButtons.push(
        <Row className="modal-btn-container">
          <Button className="cancel-option" onClick={this.handleCloseModal}>
            Cancel
          </Button>
          <Button className="button2 modalarchive" onClick={this.handleArchiveSubmit}>
            Archive
          </Button>
          {this.state.user_mode === "parent" ? (
            this.state.familyDirty ? (
              <Button className="button2 modalbtn" onClick={this.handleUpdateSubmit}>
                Update
              </Button>
            ) : null
          ) : (
            <Button className="button2 modalbtn" onClick={this.handleUpdateSubmit}>
              Update
            </Button>
          )}
        </Row>
      );
      submitButtons.push(" ")
      submitButtons.push(

    //     <Row className="modal-btn-container">
    //     <Button className="cancel-option" onClick={this.handleCloseModal}>
    //       Cancel
    //     </Button>
    //     <Button className="button2 modalbtn" onClick={this.handleArchiveSubmit}>
    //       Archive
    //     </Button>
    //     <Button className="button2 modalbtn" onClick={this.handleUpdateSubmit}>
    //       Update
    //     </Button>              
    // </Row>

      );     
    } else { //mode is new
      submitButtons.push(
     <Row className="modal-btn-container">

            <Button className="cancel-option" onClick={this.handleCloseModal}>
              Cancel
            </Button>

          <Button className="button2 modalbtn" onClick={this.handleNewSubmit}>
            Create New User
          </Button>
    
      </Row>

      );
    }


    var userOptions = []
    var user_type_arr = ["admin", "manager", "coach"]
    if (!defaultPlaceholders.type) {
        userOptions.push(<option value="" selected disabled>---</option>)
    }

    user_type_arr.forEach((type) => {
      type === user_mode ? userOptions.push(<option value={type} selected>{type.charAt(0).toUpperCase() + type.slice(1)}</option>)
      : userOptions.push(<option value={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</option>)
    })
  

    var genderOptions = []
    var gender_type_arr = ["female", "male"];
    if (!defaultPlaceholders.gender) {
        genderOptions.push(<option value="" selected disabled>---</option>)
    }
    gender_type_arr.forEach((type) => {
      type === defaultPlaceholders.gender ?  genderOptions.push(<option value={type} selected>{type.charAt(0).toUpperCase() + type.slice(1)}</option>)
      : genderOptions.push(<option value={type}>{type.charAt(0).toUpperCase() + type.slice(1)}</option>)
    })

    var parentOptions = []
    if( !parents) {
      parentOptions.push(<option value="" selected disabled>---</option>)
    }
    parents.forEach(parent => {
      parent._id === this.state.parent_id ? parentOptions.push(<option selected value={parent._id}>{parent.first_name + " " + parent.last_name}</option>)
      : parentOptions.push(<option value={parent._id}>{parent.first_name + " " + parent.last_name}</option>)
    })

    var familyMembers = []
    if (user_mode === "parent") {
      familyMembers = this.getFamilyMembers()
    }

    var formFields = [];
      if (user_mode === "parent") {
        formFields.push(
          <Fragment>
            <div className="family-modal-header">
              <div className="family-modal-copy">
                <div className="program-modal-kicker">Family Profile</div>
                <h3 className="family-modal-title">{displayName || 'Account Holder'}</h3>
              </div>
            </div>
            <div className="family-family-grid">
              <div className="family-family-column family-adult-column">
                <div className="family-card-section-title">Adult Contacts</div>
                <div className="family-adult-stack">
                  {this.renderFamilyCard(
                    'account-holder',
                    'Account Holder',
                    'Primary family contact',
                    [
                      { id: 'first_name', label: 'First Name', value: familyDraft.accountHolder.first_name, onChange: (e) => this.setFamilyDraftField('accountHolder', 'first_name', e.target.value), col: { lg: 3, sm: 6 } },
                      { id: 'last_name', label: 'Last Name', value: familyDraft.accountHolder.last_name, onChange: (e) => this.setFamilyDraftField('accountHolder', 'last_name', e.target.value), col: { lg: 3, sm: 6 } },
                      { id: 'email', label: 'Email', value: familyDraft.accountHolder.email, onChange: (e) => this.setFamilyDraftField('accountHolder', 'email', e.target.value), col: { lg: 3, sm: 6 } },
                      { id: 'phone', label: 'Phone', value: familyDraft.accountHolder.phone, onChange: (e) => this.setFamilyDraftField('accountHolder', 'phone', e.target.value), col: { lg: 3, sm: 6 } },
                    ],
                    [
                      { id: 'first_name', label: 'First Name', defaultValue: familyDraft.accountHolder.first_name },
                      { id: 'last_name', label: 'Last Name', defaultValue: familyDraft.accountHolder.last_name },
                      { id: 'email', label: 'Email', defaultValue: familyDraft.accountHolder.email },
                      { id: 'phone', label: 'Phone', defaultValue: familyDraft.accountHolder.phone },
                    ]
                  )}

                  {this.renderFamilyCard(
                    'secondary-contact',
                    'Secondary Contact',
                    'Backup family contact',
                    [
                      { id: 'secondary_parent_first_name', label: 'First Name', value: familyDraft.secondaryContact.first_name, onChange: (e) => this.setFamilyDraftField('secondaryContact', 'first_name', e.target.value), col: { lg: 3, sm: 6 } },
                      { id: 'secondary_parent_last_name', label: 'Last Name', value: familyDraft.secondaryContact.last_name, onChange: (e) => this.setFamilyDraftField('secondaryContact', 'last_name', e.target.value), col: { lg: 3, sm: 6 } },
                      { id: 'secondary_parent_email', label: 'Email', value: familyDraft.secondaryContact.email, onChange: (e) => this.setFamilyDraftField('secondaryContact', 'email', e.target.value), col: { lg: 3, sm: 6 } },
                      { id: 'secondary_parent_phone', label: 'Phone', value: familyDraft.secondaryContact.phone, onChange: (e) => this.setFamilyDraftField('secondaryContact', 'phone', e.target.value), col: { lg: 3, sm: 6 } },
                    ],
                    [
                      { id: 'secondary_parent_first_name', label: 'First Name', defaultValue: familyDraft.secondaryContact.first_name },
                      { id: 'secondary_parent_last_name', label: 'Last Name', defaultValue: familyDraft.secondaryContact.last_name },
                      { id: 'secondary_parent_email', label: 'Email', defaultValue: familyDraft.secondaryContact.email },
                      { id: 'secondary_parent_phone', label: 'Phone', defaultValue: familyDraft.secondaryContact.phone },
                    ]
                  )}
                </div>
              </div>

              <div className="family-family-column family-participant-column">
                <div className="family-card-section-title">Connected Participant</div>
                <div className="family-participant-grid">
                {familyMembers.length > 0 && familyMembers.map((athlete) => {
                  const extras = athlete.extras || {}
                  const cardKey = `participant-${athlete._id}`
                  const participantDraft = familyDraft.participants.find((participant) => participant._id === athlete._id) || {}
                  const dobValue = participantDraft.date_of_birth ? Moment.utc(participantDraft.date_of_birth) : (extras.date_of_birth ? Moment.utc(extras.date_of_birth) : null)
                  return (
                    <div className={`family-edit-card ${this.isCardEditing(cardKey) ? 'is-editing' : ''}`} key={athlete._id}>
                      <div className="family-edit-card-header">
                        <div>
                          <div className="family-edit-card-title">{athlete.first_name} {athlete.last_name}</div>
                          <div className="family-edit-card-subtitle">{athlete.email || 'No email on file'}</div>
                        </div>
                        <button
                          type="button"
                          className={`family-edit-card-toggle ${this.isCardEditing(cardKey) ? 'is-active' : ''}`}
                          onClick={() => this.toggleCardEditing(cardKey)}
                          aria-label={`Edit ${athlete.first_name} ${athlete.last_name}`}
                        >
                          <FontAwesomeIcon icon={faPen} />
                        </button>
                      </div>
                      {this.isCardEditing(cardKey) ? (
                        <div className="family-edit-card-body">
                          <Row>
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-first_name`, label: 'First Name', value: participantDraft.first_name || athlete.first_name, onChange: (e) => this.setFamilyDraftField('participant', 'first_name', e.target.value, athlete._id), col: { lg: 3, sm: 6 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-last_name`, label: 'Last Name', value: participantDraft.last_name || athlete.last_name, onChange: (e) => this.setFamilyDraftField('participant', 'last_name', e.target.value, athlete._id), col: { lg: 3, sm: 6 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-email`, label: 'Email', value: participantDraft.email || athlete.email, onChange: (e) => this.setFamilyDraftField('participant', 'email', e.target.value, athlete._id), col: { lg: 3, sm: 6 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-phone`, label: 'Phone', value: participantDraft.phone || extras.phone, onChange: (e) => this.setFamilyDraftField('participant', 'phone', e.target.value, athlete._id), col: { lg: 3, sm: 6 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-date_of_birth`, label: 'Date of Birth', type: 'date', selectedValue: dobValue, value: participantDraft.date_of_birth || extras.date_of_birth, onChange: (date) => this.setFamilyDraftField('participant', 'date_of_birth', date, athlete._id), col: { lg: 3, sm: 6 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-gender`, label: 'Gender', type: 'select', value: participantDraft.gender || extras.gender || '', onChange: (e) => this.setFamilyDraftField('participant', 'gender', e.target.value, athlete._id), options: genderOptions, col: { lg: 3, sm: 6 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-current_school`, label: 'Current School', value: participantDraft.current_school || extras.current_school, onChange: (e) => this.setFamilyDraftField('participant', 'current_school', e.target.value, athlete._id), col: { lg: 3, sm: 6 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-city`, label: 'City', value: participantDraft.city || extras.city, onChange: (e) => this.setFamilyDraftField('participant', 'city', e.target.value, athlete._id), col: { lg: 3, sm: 6 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-address`, label: 'Address', value: participantDraft.address || extras.address, onChange: (e) => this.setFamilyDraftField('participant', 'address', e.target.value, athlete._id), col: { lg: 6, sm: 12 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-province`, label: 'Province', value: participantDraft.province || extras.province, onChange: (e) => this.setFamilyDraftField('participant', 'province', e.target.value, athlete._id), col: { lg: 3, sm: 6 } })}
                            {this.renderFamilyCardField(cardKey, { id: `${cardKey}-postal_code`, label: 'Postal Code', value: participantDraft.postal_code || extras.postal_code, onChange: (e) => this.setFamilyDraftField('participant', 'postal_code', e.target.value, athlete._id), col: { lg: 3, sm: 6 } })}
                          </Row>
                        </div>
                      ) : (
                        <div className="family-summary-grid family-summary-grid-compact">
                          <div>
                            <span>Email</span>
                            <div>{athlete.email || '-'}</div>
                          </div>
                          <div>
                            <span>Phone</span>
                            <div>{extras.phone || '-'}</div>
                          </div>
                          <div>
                            <span>DOB</span>
                            <div>{dobValue ? dobValue.format('MMM DD, YYYY') : '-'}</div>
                          </div>
                          <div>
                            <span>School</span>
                            <div>{extras.current_school || '-'}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  )
                })}
                </div>
              </div>
            </div>
        </Fragment>
      )
    } else if (user_mode === "athlete") {
      formFields.push(
        <div>
        
        <Row>
          <Col lg={6}>
           <h2>Participant</h2>
          </Col>
        </Row>

          <Row>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <ControlLabel>First Name</ControlLabel>
                    <FormControl className="opaque-grey" name="first_name" type="text" id="first_name" defaultValue={defaultPlaceholders.first_name} />
                  </FormGroup>
                </Col>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <ControlLabel>Last Name</ControlLabel>
                    <FormControl className="opaque-grey" name="last_name" type="text" id="last_name" defaultValue={defaultPlaceholders.last_name} />
                  </FormGroup>
                </Col>
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <ControlLabel>Date of Birth</ControlLabel>
                    <DatePicker className="opaque-grey form-control" name="date_of_birth" id={"date_of_birth"} utcOffset={0} selected={date_of_birth ? date_of_birth : null} placeholderText="MM/DD/YYYY" showYearDropdown onChange={this.handleDateOfBirthChange} />
                  </FormGroup>
                </Col>                  
                <Col lg={3} sm={6}>
                  <FormGroup>
                    <ControlLabel>Gender</ControlLabel>
                    <FormControl className="opaque-grey" name="gender" id="gender" componentClass="select">
                      {genderOptions}
                    </FormControl>
                  </FormGroup>
                </Col>    
                <Col lg={6} sm={12}>                
                  <FormGroup>
                  <ControlLabel>Parent Account</ControlLabel>
                  <FormControl className="opaque-grey" name="parent_id" id="parent_id" componentClass="select">
                    {parentOptions}
                  </FormControl>
                </FormGroup>
                </Col>                              
                </Row>

                <Row>
                  <Col lg={6}>
                  <h2>Participant Contact</h2>
                  </Col>
                </Row>

                <Row>  
                  <Col lg={3} sm={6}>
                    <FormGroup>
                      <ControlLabel>Email</ControlLabel>
                      <FormControl className="opaque-grey" name="email" type="text" id="email" defaultValue={defaultPlaceholders.email} />
                    </FormGroup>
                  </Col>
                  <Col lg={3} sm={6}>
                    <FormGroup>
                      <ControlLabel>Phone</ControlLabel>
                      <FormControl className="opaque-grey" name="phone" type="text" id="phone" defaultValue={defaultPlaceholders.phone} />
                    </FormGroup>
                  </Col>                                                                       
                  <Col lg={3} sm={6}>
                    <FormGroup>
                      <ControlLabel>Current School</ControlLabel>
                      <FormControl className="opaque-grey" name="current_school" type="text" id="current_school" defaultValue={defaultPlaceholders.current_school} />
                    </FormGroup>
                  </Col>
                  <Col lg={3} sm={6}>
                    <FormGroup>
                      <ControlLabel>City</ControlLabel>
                      <FormControl className="opaque-grey" name="city" type="text" id="city" defaultValue={defaultPlaceholders.city} />
                    </FormGroup>
                  </Col> 
                  <Col lg={6} sm={4}>
                    <FormGroup>
                      <ControlLabel>Address</ControlLabel>
                      <FormControl className="opaque-grey" name="address" type="text" id="address" defaultValue={defaultPlaceholders.address} />
                    </FormGroup>
                  </Col> 
                  <Col lg={3} sm={4}>
                    <FormGroup>
                      <ControlLabel>Province</ControlLabel>
                      <FormControl className="opaque-grey" name="province" type="text" id="province" defaultValue={defaultPlaceholders.province} />
                    </FormGroup>
                  </Col>
                  <Col lg={3} sm={4}>
                    <FormGroup>
                      <ControlLabel>Postal Code</ControlLabel>
                      <FormControl className="opaque-grey" name="postal_code" type="text" id="postal_code" defaultValue={defaultPlaceholders.postal_code} />
                    </FormGroup>
                  </Col>               
                </Row>

              <Row>
                <Col lg={6}>
                  <h2>Notes and custom fields</h2>
                </Col>
              </Row>              

              <Row>      
              <Col lg ={12} md={12} sm={12}>
                  <FormGroup>
                    <ControlLabel>Additionl Notes at Registration</ControlLabel>
                    <FormControl className="opaque-grey" name="parent_notes" componentClass="textarea" id="parent_notes" defaultValue={defaultPlaceholders.parent_notes} />
                  </FormGroup>
                </Col>                      
                <Col lg={12} sm={12}>
                  {
                    defaultPlaceholders.udfs && orgUDFs ?
                    this.UDFinfo(defaultPlaceholders.udfs): ''
                  }
                </Col>  

              </Row>  
        </div>
      )
    } else {
      formFields.push(
        <div>
          <h2>{user_mode.charAt(0).toUpperCase() + user_mode.slice(1).toLowerCase()} Information</h2>
          <Row>
            <Col lg={2} sm={4}>
              <FormGroup>
                  <ControlLabel>Type</ControlLabel>
                  <FormControl className="opaque-grey" name="type" componentClass="select" id="type" >
                    {userOptions}
                  </FormControl>
              </FormGroup>
            </Col>
          </Row>

          <Row>
            <Col lg={2} sm={4}>
              <FormGroup>
                <ControlLabel>First Name</ControlLabel>
                <FormControl className="opaque-grey" name="first_name" type="text" id="first_name" defaultValue={defaultPlaceholders.first_name} />
              </FormGroup>
            </Col>
            <Col lg={3} sm={4}>
              <FormGroup>
                <ControlLabel>Last Name</ControlLabel>
                <FormControl className="opaque-grey" name="last_name" type="text" id="last_name" defaultValue={defaultPlaceholders.last_name} />
              </FormGroup>
            </Col>
            <Col lg={3} sm={4}>
              <FormGroup>
                <ControlLabel>Email</ControlLabel>
                <FormControl className="opaque-grey" name="email" type="text" id="email" defaultValue={defaultPlaceholders.email} />
              </FormGroup>
            </Col>
            <Col lg={2} sm={4}>
              <FormGroup>
                <ControlLabel>Phone</ControlLabel>
                <FormControl className="opaque-grey" name="phone" type="text" id="phone" defaultValue={defaultPlaceholders.phone} />
              </FormGroup>
            </Col>       
            <Col lg={2} sm={4}>
              <FormGroup>
                <ControlLabel>Date of Birth</ControlLabel>
                <DatePicker className="opaque-grey form-control" name="date_of_birth" id={"date_of_birth"} utcOffset={0} selected={date_of_birth} placeholderText="MM/DD/YYYY" showYearDropdown onChange={this.handleDateOfBirthChange} />
              </FormGroup>
            </Col>                   
            </Row>

            <Row>   
                                 

          </Row>

      </div>
    )
  }

  return (
    <form>
    <div className="transaction-modal-header">
      <div>
        <div className="transaction-modal-kicker">Users</div>
        <h3 className="transaction-modal-title">{modalTitle}</h3>
        <div className="transaction-modal-subtitle">{modalSubtitle}</div>
      </div>
      <div className="transaction-modal-summary">
        <div className="transaction-modal-summary-label">Role</div>
        <div className="transaction-modal-summary-value">{modalSummaryValue}</div>
      </div>
    </div>
    <Row className="modal-formfields">
      <Col>
        {formFields}
      </Col>
    </Row>    
            <div className="modal-formbuttons">
      {
      this.state.spinner ?
      <div key={makeUniqueKey()} className="enrolment-loader"></div>
      :
      submitButtons
      }
    </div>

    </form>
    )
  }
}

export default UserForm;
